import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "money",
  "use": "money-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"money\"><defs><style></style></defs><path d=\"M830.784 489.301l45.099 45.398-322.283 320-14.656-14.763 14.741 14.89h-45.013v-45.375l-.15-.15 322.262-320zm-84.117-318.634a64 64 0 0164 64v192l-64 64v-256h-352v554.666H448l-64 64H277.333a64 64 0 01-64-64V234.667a64 64 0 0164-64h469.334zm-416 64h-53.334v554.666h53.334V234.667zm288 192v64H448v-64h170.667zm64-128v64H448v-64h234.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol